import { useValidateCartOnMount } from '../../hooks/use-validate-cart-on-mount'

export const ValidateCart = () => {
  useValidateCartOnMount()
  return null
}
